import React from 'react';
import BusinessObjectFormComponent from '../../components/business-object-form/business-object-form.component';
import { makeStyles } from '@mui/styles';
import { Link, useOutletContext } from 'react-router-dom';
import { User } from '../../../../../../models/interfaces/User.interface';
import routeService from '../../../../../../routes/route.service';

const useStyles = makeStyles({
  title: {
    fontSize: '20px',
    marginBottom: '20px',
  },
});

export default function BusinessObjectCreateComponent() {
  const { user } = useOutletContext<{ user: User }>();

  const classes = useStyles();

  return (
    <div>
      <div className={classes.title}>Create new business object</div>

      {user?.id ? <BusinessObjectFormComponent owner={user} /> : <></>}

      <Link to={`${routeService.getAndFillUserDetailPath(user?.id)}`}>Back to user detail</Link>
    </div>
  );
}
